import React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { Timer } from '@/components/common/Timer/Timer';
import { H1, StringSmall } from '@/components/Typography/Typography';

interface props {
  timer: number;
  classNames?: string;
}

const WarningTimer: React.FC<props> = ({ timer, classNames }) => {
  const { t } = useTranslation();

  return (
    <div className={cn('flex flex-col gap-2 items-center w-full', classNames)}>
      <div className="flex gap-[2px]">
        <H1 className="!text-[20px] !font-[700]">{t('Warning')}</H1>
        <img src="/img/icons/warning.png" alt="" className="w-[24px]" />
      </div>
      <StringSmall className="!text-[14px] !font-[400]">
        {t('Less time to complete a contract')}
      </StringSmall>
      <StringSmall className="!text-[14px] !font-[400]">
        {t('The contract will be renewed in:')}
      </StringSmall>
      <div className="bg-[#FFFFFF0D] py-[6px] px-[12px] rounded-full">
        <Timer seconds={timer} template="{hours} : {minutes} : {seconds}" />
      </div>
    </div>
  );
};

export default WarningTimer;
